import { useTranslation } from "react-i18next";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { type MetadataValues } from "@/components/accounts/metadata";

interface Props {
  values: MetadataValues;
  onChange: (next: MetadataValues) => void;
}

/**
 * MetadataForm — the 6 seller-analytics fields (source_label, source_url,
 * purchase_cost, purchase_date, seller_age, country_code). One implementation,
 * was duplicated in the Single + Zip import flows.
 */
export function MetadataForm({ values, onChange }: Props) {
  const { t } = useTranslation();
  const set = (patch: Partial<MetadataValues>) => onChange({ ...values, ...patch });

  return (
    <div className="grid grid-cols-2 gap-3">
      <div className="col-span-2 space-y-1">
        <Label className="text-xs">{t("accounts.field.source_label")}</Label>
        <Input
          value={values.sourceLabel}
          onChange={(e) => set({ sourceLabel: e.target.value })}
          placeholder={t("accounts.field.source_label_placeholder")}
        />
      </div>
      <div className="col-span-2 space-y-1">
        <Label className="text-xs">{t("accounts.field.source_url")}</Label>
        <Input
          type="url"
          value={values.sourceUrl}
          onChange={(e) => set({ sourceUrl: e.target.value })}
          placeholder="https://..."
        />
      </div>
      <div className="space-y-1">
        <Label className="text-xs">{t("accounts.field.purchase_cost")}</Label>
        <Input
          type="number"
          step="0.01"
          min="0"
          value={values.purchaseCost}
          onChange={(e) => set({ purchaseCost: e.target.value })}
          placeholder="5.00"
        />
      </div>
      <div className="space-y-1">
        <Label className="text-xs">{t("accounts.field.purchase_date")}</Label>
        <Input
          type="date"
          value={values.purchaseDate}
          onChange={(e) => set({ purchaseDate: e.target.value })}
        />
      </div>
      <div className="space-y-1">
        <Label className="text-xs">{t("accounts.field.seller_age_days")}</Label>
        <Input
          type="number"
          min="0"
          value={values.sellerAge}
          onChange={(e) => set({ sellerAge: e.target.value })}
          placeholder="180"
        />
      </div>
      <div className="space-y-1">
        <Label className="text-xs">{t("accounts.field.country_code")}</Label>
        <Input
          maxLength={2}
          value={values.countryCode}
          onChange={(e) => set({ countryCode: e.target.value.toUpperCase() })}
          placeholder="US"
        />
      </div>
    </div>
  );
}
